export default class Config {
    // Beta-account pool, not the beta stage's gamma-account one. Its stream has no Firehose.
    public static readonly COGNITO_IDENTITY_POOL_ID_DEV = 'us-west-2:3b7b3106-8721-4564-9286-85191057848e';
    public static readonly PINPOINT_APP_ID_DEV = 'f89f2d057481475583d08930f4ab4717';
}
